<template>
	<div class="customerTake" :style="{'background-image':backgroundimage}">
		<div class="company_logo" v-if="company.Logo">
			<img :src="company.Logo" alt="logo">
		</div>
		<div id="cusCard" >
			<h2 style="text-align:center;margin-top:10px;margin-bottom:20px;">客户预约</h2>
			<div class="mstep">
				<el-steps :active="active" finish-status="success" :align-center="true">
					<el-step title="验证卡券"></el-step>
					<el-step title="填写信息"></el-step>
					<el-step title="提交预约"></el-step>
				</el-steps>
			</div>

			<div v-show="active==1" v-cloak>
				<el-row>
					<el-col :xs="24" :md="{ span: 12, offset: 6 }">
						<!-- <el-input id="number" type="text" placeholder="请输入卡号" :value="Card.Number">
							<template slot="prepend">
								卡号
							</template>
						</el-input> -->
						<div class="el-input el-input-group el-input-group--prepend"><div class="el-input-group__prepend">
							卡号
						</div><input type="text" autocomplete="off" id="number" v-model.trim="Card.Number" placeholder="请输入卡号" class="el-input__inner">
						</div>
						<el-input placeholder="请输入密码" v-model.trim="Card.Password" style="margin-top:15px;">
							<template slot="prepend">
								密码
							</template>
						</el-input>
						<el-button type="danger" style="width:100%;margin-top:15px;" :loading="isCheck" v-on:click="checkCard()" >验证</el-button>

						<!-- <el-card class="box-card" v-for="(x, index) in CardList" :key="x.Id">
							<div slot="header" class="clearfix">
								<span style="line-height: 28px;">{{index+1}}、{{x.cardNumber}}</span>
								<el-button style="float: right;" type="primary" size="mini" v-on:click="delCard(index)">删除</el-button>
							</div>
							<div class="selected-pro">
								<div class="pro-panel-wrap" v-for="(item, index) in x.product"
									:class="{'pro-select':x.selectedProduct && x.selectedProduct.Id && item.Id == x.selectedProduct.Id}" v-on:click="selectPoint(x,item)">
									<div class="panel-left">
										<div>
											<img :src="item.Photo ? ossUrl + item.Photo : '/static/img/default_pro.jpg' " />
										</div>
									</div>
									<div class="panel-mid">
										<h4>{{item.Name}}</h4>
										<p>
											{{item.Desc}}
										</p>
									</div>
									<div class="panel-right" >
										<i class="el-icon-view" v-if="item.DetailImage" v-on:click="showDetail(item)"></i>
									</div>
									<div class="panel-checked" v-if="x.selectedProduct && x.selectedProduct.Id && item.Id == x.selectedProduct.Id">
										<i class="el-icon-s-flag"></i>
									</div>
								</div>
							</div>
						</el-card> -->
						<el-collapse v-model="cardIndex" accordion v-if="CardList.length>0" style="margin-top:5px;">
							<el-collapse-item v-for="(x, index) in CardList" :key="x.Id" class="card_title" :name="index">
								<template slot="title">
									<el-link type="danger" style="margin-left:5px;margin-right:5px;min-width:30px;" v-on:click="delCard(index)">移除</el-link>
									<span style="margin-right:10px;min-width:80px;">{{x.Number}}</span>
									<!-- <span v-if="!x.SelectedProducts" style="color:#F56C6C">未选择产品</span> -->
									<span v-if="!x.Multiple">{{x.currentProName}}</span>
									<span v-if="x.Multiple">已选<a style="color:#F56C6C">{{x.SelectedProPrice}}</a>/{{x.DefinePrice}}点</span>
								</template>
								
								<div class="selected-pro">
									<div v-if="x.Multiple">
										<el-row v-for="(s,i) in x.SelectProducts" :key="i">
											<el-col :span="18">{{s.Name}}</el-col>
											<el-col :span="4">{{s.Count}}份</el-col>
											<el-col :span="2"><i @click="deleteItem(x,s,i)" class="el-icon-delete-solid" style="font-size:22px;"></i></el-col>
										</el-row>
										<br />
									</div>
									<div class="pro-panel-wrap" v-for="item in x.Products" :key="item.Id"
										:class="{'pro-select':x.Spids.indexOf(item.Id)>-1}" v-on:click="selectPoint(x,item)">
										<div class="panel-left">
											<el-image
												style="width: 100px; height: 100px"
												:src="item.Photo ? ossUrl + item.Photo : '/static/img/default_pro.jpg' "
												fit="contain"></el-image>
										</div>
										<div class="panel-mid">
											<h4>{{item.Name}}</h4>
											<div v-if="item.Deleted">已下架</div>
											<div v-if="item.ExpiryDate">截止{{item.ExpiryDate |toTimeFormat}}</div>
											<div v-if="x.Multiple" class="proPiont">{{item.DefinePrice}}点</div>
										</div>
										<div class="panel-right" >
											<i class="el-icon-picture-outline-round" v-if="item.Desc.length>10" v-on:click="showDetail(item)"></i>
										</div>
										<!-- <div class="panel-checked" v-if="x.selectedProduct && x.selectedProduct.Id && item.Id == x.selectedProduct.Id">
											<i class="el-icon-s-flag"></i>
										</div> -->
									</div>
								</div>
							</el-collapse-item>
						</el-collapse>

						<div></div>
						<div v-show="CardList && CardList.length>0" style="margin-top: 15px;text-align: center;">
							<el-button v-on:click="addnewcard" type="primary" icon="el-icon-plus">添加新卡</el-button>
							<el-button v-on:click="next('card')" type="success" icon="el-icon-check">下一步</el-button>
						</div>
						

					</el-col>

				</el-row>
			</div>

			<div v-show="active==2">
				<el-row>
					<el-col :xs="24" :md="{ span: 12, offset: 6 }">
						<el-form label-position="right" label-width="80px" :model="Take">
							<el-form-item label="姓名">
								<el-input v-model="Take.Name" placeholder="请输入姓名"></el-input>
							</el-form-item>
							<el-form-item label="联系方式">
								<el-input v-model="Take.Phone" placeholder="请输入手机号"></el-input>
							</el-form-item>
							<el-form-item label="省市区">
								<el-row>
									<el-col :span="8">
										<el-select v-model="Province" value-key='areaCode' v-on:change="getCity" placeholder="请选择省份...">
											<el-option v-for="item in AllProvinces"
											           :key="item.areaCode"
											           :label="item.fullName"
											           :value="item">
											</el-option>
										</el-select>
									</el-col>
									<el-col :span="8">
										<el-select v-model="City" value-key='areaCode' v-on:change="getDistrict" placeholder="请选择城市...">
											<el-option v-for="item in Cities"
											           :key="item.areaCode"
											           :label="item.fullName"
											           :value="item">
											</el-option>
										</el-select>
									</el-col>
									<el-col :span="8">
										<el-select v-model="District" value-key='areaCode' placeholder="请选择区县...">
											<el-option v-for="item in Districts"
											           :key="item.areaCode"
											           :label="item.fullName"
											           :value="item">
											</el-option>
										</el-select>
									</el-col>
								</el-row>
							</el-form-item>
							<el-form-item label="详细地址">
								<el-input v-model="Take.Address" placeholder="请填写详细地址"></el-input>
							</el-form-item>
							<el-form-item :label="company.TakeDateType?`发货日期`:`收货日期`">
								<el-date-picker type="date" :picker-options="pickerOptions" placeholder="选择日期" :editable="false" v-model="Take.ExpectDeliveredDate" style="width: 100%;" format="yyyy-MM-dd"></el-date-picker>
							</el-form-item>
							<el-form-item label="备注">
								<el-input v-model="Take.Remark" placeholder="如您有其他需求，可在此处填写"></el-input>
							</el-form-item>
						</el-form>

						<el-row>
							<el-col :span="24" style="text-align: center;">
								<el-button type="info" icon="el-icon-back" v-on:click="pre">返回修改</el-button>
								<el-button type="success" icon="el-icon-check" v-on:click="next">下一步</el-button>
							</el-col>
						</el-row>

					</el-col>
				</el-row>
			</div>

			<div v-show="active==3">
				<el-row>
					<el-col :xs="24" :md="{ span: 12, offset: 6 }">
						<el-row>
							<el-col :span="24" style="background-color:#fff;padding:5px;border-radius:10px;">
								<span class="sum_tips">*请核对预约信息是否正确</span>
								<table cellspacing="0" cellpadding="0" border="1" class="el-table__body sum_table" style="    border-collapse: collapse;" >
									<tbody>
										<tr class="el-table__row" v-for="item in CardList" :key="item.Id">
											<td class="sum_table_title">
												<div class="sum_cell">{{item.Number}}</div>
											</td>
											<td class="sum_table_content">
												<div class="sum_cell" v-if="item.SelectProducts">
													<span style="float:left;" v-for="s in item.SelectProducts" :key="s.Id">{{s.Name}}X{{s.Count}}份</span>
												</div>
											</td>
										</tr>
										<tr class="el-table__row">
											<td class="sum_table_title">
												<div class="sum_cell">收货人:</div>
											</td>
											<td class="sum_table_content">
												<div class="sum_cell">{{Take.Name}}</div>
											</td>
										</tr>
										<tr class="el-table__row">
											<td class="sum_table_title">
												<div class="sum_cell">手机:</div>
											</td>
											<td class="sum_table_content">
												<div class="sum_cell">{{Take.Phone}}</div>
											</td>
										</tr>
										<tr class="el-table__row">
											<td class="sum_table_title">
												<div class="sum_cell">地址:</div>
											</td>
											<td class="sum_table_content">
												<div class="sum_cell">{{Province.fullName}}&nbsp;&nbsp;{{City.fullName}}&nbsp;&nbsp;{{District.fullName}}&nbsp;&nbsp;{{Take.Address}}</div>
											</td>
										</tr>
										<tr class="el-table__row">
											<td class="sum_table_title">
												<div class="sum_cell">{{company.TakeDateType?`发货日期`:`收货日期`}}</div>
											</td>
											<td class="sum_table_content">
												<div class="sum_cell">{{Take.ExpectDeliveredDate | toTimeFormat(false)}}</div>
											</td>
										</tr>
										<tr class="el-table__row">
											<td class="sum_table_title">
												<div class="sum_cell">备注:</div>
											</td>
											<td class="sum_table_content">
												<div class="sum_cell">{{Take.Remark}}</div>
											</td>
										</tr>
									</tbody>
								</table>
							</el-col>
						</el-row>
						<!-- <el-row v-for="item in CardList">
							<el-col :span="8">{{item.cardNumber}}</el-col>
							<el-col :span="16" v-if="item.selectedProduct">{{item.selectedProduct.Name}}</el-col>
						</el-row> -->
						<el-row>
							<el-col :span="24" style="text-align: center;margin-top:10px;">
								<el-button type="info" icon="el-icon-back" v-on:click="pre">返回修改</el-button>
								<el-button type="success" icon="el-icon-check" :loading="isPost" v-on:click="CustomerTake">确认预约</el-button>
							</el-col>
						</el-row>

					</el-col>
				</el-row>
			</div>

		</div>

		<!-- 产品详情dialog -->
		<el-dialog title="产品详情" :visible.sync="showDeatil" custom-class="proDetail">
			<div v-html="viewDetail.Desc"></div>
		</el-dialog>

		<div class="focuson">
			<!-- <img src="/static/img/weixin_guazhu.jpg" />
			<p>长按关注公共号</p> -->
		</div>
	</div>
</template>

<script>
	import axios from 'axios'
	import {toTimeFormat} from '@/filters/index'
	export default {
		name: 'CustomerTakeOrder',
		data(){
			let _this = this;
			return {
				active: 1,
				Card: {},
				CardList: [],
				Take: { ExpectDeliveredDate: "" },
				Province: "",
				City: {},
				District: {},
				AllProvinces: [],
				allAddress: [], //存储所有省市区备用
				Cities: [],
				Districts: [],
				isCheck: false,
				isPost: false,
				showiframe: true,
				pickerOptions: {
					disabledDate(time) {
						let now  = new Date();
						// let n = now.getHours() > 14 ? 2 : 1;
						// let oldDay = time.getTime() < new Date(now.getTime() + 1000*3600*24*n);//之前日期不能预约
						// let exceptDay = (time.getDay() == 1 || time.getDay() == 0) ;//周六周一不能预约
						// console.log(time.getMonth())
						// //- 8.64e7
						// let octDay = time.getMonth() == 1 && (time.getDate() < 28 && time.getDate() > 12);
						// if(time.getMonth() == 1 && time.getDate() ==11) return false;
						//console.log(1);
						// return oldDay || exceptDay || octDay;
						let n = _this.getUiDisableNumber();
						n+=_this.delayDay;
						let oldDay=time.getTime() < new Date(now.getTime() + 1000*3600*24*(n-1));//之前日期不能预约
						let exceptDay=false;
						if(_this.roleModel.ExpiryDate){
							var ed=new Date(_this.roleModel.ExpiryDate.split('T')[0]);
							exceptDay=time.getTime()>ed.getTime();
						}
							
						let isDisable = _this.roleModel.DisableDate.filter((item)=>{
							return time.getFullYear() == new Date(item).getFullYear() && time.getMonth() == new Date(item).getMonth() && time.getDate() == new Date(item).getDate();
						})
						//if(_this.roleModel.WeekendDelay){
						// for (let i = 1; i <= n; i++) {
						// 	let nd = new Date(new Date().getTime() + 24 * 60 * 60 * 1000 * i);
						// 	if (nd.getDay() == 6 || nd.getDay() == 0){
						// 		n = n+1;
						// 	}
						// }
						//}
						
						return oldDay||exceptDay|| isDisable.length >0;
					}
				},
				cardIndex:0,
				roleModel: {
					AfterDate: 0,
					DelayTime: "24:00",
					WeekendDelay: false,
					DisableDate: [],
					ExpiryDate:null
				},
				company: { }, //客户公司
				backgroundimage: 'url("/data/img/bg.jpg")',
				viewDetail:{},
				showDeatil:false,
				delayDay:0,
				timespan:''
			}
		},
		created: function(){
			var _this = this;
			_this.$nextTick(function () {
				axios.get("https://cdn.minica.cn/files/provinceCity.json", {})
					.then((res)=>{
						_this.AllProvinces = res.data.obj;
						_this.allAddress = _this.lodash.cloneDeep(res.data.obj); //存储所有省市区备用
					})

				if(_this.$route.params.Id){
					_this.Card.Number =  _this.$route.params.Id;
					_this.getTake();
				}else {
					//_this.showMsg()
				}
				// console.log(_this.lodash.max(["08:00", "19:10"]));
				// _this.getRule();
				_this.getCompany();
				_this.timespan= (new Date()).valueOf();
			})
		},
		methods: {
			next: function (step) {
				let _this = this;
				if(step=='card'){
					let errlist = _this.CardList.filter((item)=>{
						return item.SelectProducts && item.SelectProducts.length > 0;
					})
					if(errlist.length != _this.CardList.length){
						_this.$message.error('您有卡券未选择产品!');
						return false;
					}
				}
				if (this.active++ > 2) this.active = 3;
			},
			pre: function(){
				if (this.active-- < 1) this.active = 1;
			},
			addnewcard(){
				var _this=this;
				_this.cardIndex=-1;
				_this.Card.Number='';
				_this.Card.Password='';

				number.scrollIntoView();
			},
			focusStep: function (step) {
				alert(step)
				this.active = step;
			},
			proItemChange(e,card){
                var sum=0;
                if(card.SelectProducts.length>0){
                    card.SelectProducts.forEach(x=>{
                        sum+=x.DefinePrice*x.Count;
                    })
                }
                card.SelectedProPrice=sum;
			},
			deleteItem(s,item,i){
				s.SelectProducts.splice(i,1);
				s.SelectedProPrice-=item.DefinePrice;
				this.$forceUpdate();
			},
			getTake(){
				let _this = this;
				axios.post( _this.gbaseURL + "/TakeOrder/GetBackGroundImage",{"Number":  _this.$route.params.Id}).then(image=>{
					if(image.data.State==1){
						if(image.data.Data){
							_this.backgroundimage='url("'+_this.ossUrl+image.data.Data+'")';
						}
						axios.post( _this.gbaseURL + "/TakeOrder/GetInfoByCardNumber", {"Number":  _this.$route.params.Id} )
						.then(res => {
							
							var data = res.data;
							if(data.State==1){
								if([50.60].indexOf(data.Data.Status)>-1){
									_this.$router.push({ path: '/Card/Detail/' + _this.$route.params.Id })
								}else {
									_this.showMsg();
								}
							}else {
								if(data.ErrorMsg && data.ErrorMsg == "请稍后再试"){
									_this.$message.error(data.ErrorMsg);
								}
							}
						})
					}
				})
				
			},
			showDetail(item){
				this.viewDetail=item;
				this.showDeatil=true;
			},

			openProPanel(editPro, index){
				let _this = this;
				_this.proPanel = true;
				_this.editModel = _this.lodash.cloneDeep(editPro);
				_this.editIndex = index;
			},
			setCardPrice(card){
				var sum=0;
				var spids=[];
                if(card.SelectProducts.length>0){
                    card.SelectProducts.forEach(x=>{
						sum+=x.DefinePrice*x.Count;
						spids.push(x.Id);
                    })
                }
				card.SelectedProPrice=sum;
				card.Spids=spids;
			},
			selectPoint(model,item){
				let _this = this;
				//_this.editModel.selectedProduct = _this.lodash.cloneDeep(item);
				// _this.proPanel = false;
				if(item.Deleted){
					return;
				}
				if(!model.SelectProducts)model.SelectProducts=[];
				if(!model.Multiple)model.SelectProducts=[];
				if(item.ExpiryDate){
					var t=new Date();
					var t=new Date(t.setDate(t.getDate()))
					if(new Date(item.ExpiryDate)<t){
						return;
					}
					
				}
				model.currentProName=item.Name;
				if(model.Multiple){
					var old=model.SelectProducts.filter(x=>x.Id==item.Id);
					if(model.DefinePrice<(model.SelectedProPrice+item.DefinePrice))
					{
						return;
					}
					if(old&&old.length>0){
						if(model.RepeatProduct){
							old[0].Count++;
						}else{
							return;
						}
						
					}else{
						model.SelectProducts.push(_this.lodash.cloneDeep(item));
					}
					
				}else{

					model.SelectProducts.push(_this.lodash.cloneDeep(item));
				}
				this.setCardPrice(model);
				//_this.CardList.splice(_this.editIndex, 1, {cardId:Id,number:number,selectedProduct:_this.lodash.cloneDeep(item)});
				_this.rebuildProvince();
				
				// _this.roleModel.AfterDate=_this.roleModel.AfterDate-_this.delayDay+item.DelayDelivery;
				// _this.roleModel.ExpiryDate=item.ExpiryDate;
				if(_this.delayDay<item.DelayDelivery)_this.delayDay=item.DelayDelivery;
			},
			getCompany(){
				let _this = this;
				_this.server.post("/Company/GetCureentCompany", {}).then((res)=>{
					let data = res.data;
					if(data.State==1){
						_this.company = data.Data;
						//$("title").html(data.Data.CompanyName);
						document.getElementsByTagName("title")[0].innerHTML = "在线预约";
						_this.getRule();
					}
				})
			},
			getRule(){
				let _this = this;
				let hostname = location.hostname;
				hostname = (hostname == "localhost" || hostname == "www.yuanlei.com") ? "" : hostname;
				// { cardNumber: _this.Card.Number, hostname: hostname }  /Takerule/GetCommonRuleByCardNumber
				_this.server.post("/Takerule/GetCommonRuleByCompanyId", _this.company.Id)
					.then((res)=>{
						let data = res.data;
						if (data.State==1) {
							_this.roleModel = {
								AfterDate: data.Data.AfterDate,
								DelayTime: data.Data.DelayTime,
								WeekendDelay: data.Data.WeekendDelay,
								DisableDate: data.Data.DisableDate
							}

							if(data.Data.FrontMessage){
								_this.$notify({
									title: '温馨提示',
									message: data.Data.FrontMessage,
									dangerouslyUseHTMLString: true,
									duration: 0,
									customClass: 'tipmsg',
									type: 'warning'
								});
							}


						}
					}).catch((err)=>{ })

			},
			getUiDisableNumber(roleModel){
				// console.log("roleModel");
				let _this = this;
				let now = new Date();
				let n = 0; //向后延迟收货天数
				n = _this.roleModel.AfterDate && _this.roleModel.AfterDate>0 ? _this.roleModel.AfterDate : 0;// 延后天数
				
				let [hour, minute] = _this.roleModel.DelayTime.split(":");
				n = now.getHours() > parseInt(hour) || (now.getHours()==parseInt(hour) && now.getMinutes() > parseInt(minute)) ? n+1 : n; //超过时间点再向后延一天
				// let range = _this.lodash.cloneDeep(n);
				// for (var i = 1; i <= range; i++) {
				//     var nd = new Date(new Date().getTime() + 24 * 60 * 60 * 1000 * i);
				//     if (nd.getDay() == 6){
				//       n = n+2
				//       break;
				//     } //周六顺延2天
				//     if (nd.getDay() == 0){
				//       n = n+1;
				//       break;
				//     } //周日顺延1天
				// }

				
				//console.log(n)

				return n;
			},
			// getRuleModel(){
			// 	//构建规则模型
			// 	let _this = this;
			// 	let ruleList = _this.lodash.uniqBy(_this.ruleList, 'Id'); //去重
			// 	// let ruleList = _this.ruleList;
			// 	let AfterDate = []; //预约第几天发货
			// 	let DelayTime = []; // 多少时间之前
			// 	let DisableDate = []; //不可预约日期
			// 	let WeekendDelay = []; //周六周日顺延
			// 	ruleList.forEach((item)=>{
			// 		AfterDate.push(item.AfterDate);
			// 		DelayTime.push(item.DelayTime);
			// 		DisableDate.push(item.DisableDate);
			// 		WeekendDelay.push(item.WeekendDelay);
			// 	});
			// 	_this.roleModel = {};
			// 	_this.roleModel = {
			// 		AfterDate: _this.lodash.max(AfterDate),
			// 		DelayTime: _this.lodash.max(DelayTime),
			// 		WeekendDelay: WeekendDelay.indexOf(true)>-1 ? true : false,
			// 		DisableDate: _this.lodash.uniq(_this.lodash.flattenDeep(DisableDate)).map((item)=>{
			// 			return toTimeFormat(item);
			// 		})
			// 	}
			// 	//console.log(_this.roleModel, "ds");
			// },
			checkCard: function () {
				var _this = this;

				if (!_this.Card.Number || !_this.Card.Password) {
					_this.$message.error('请先填写卡号和密码！');
					return false;
				}

				var reCards = _this.CardList.filter(function (item, index) {
					return item.Number.toLowerCase() == _this.Card.Number.toLowerCase();
				})

				if (reCards && reCards.length > 0) {
					_this.$message.error('您验证的卡券已验证，请不要重复验证！');
					return false;
				}
				// _this.CardList.forEach(item=>{
				// 	if(!item.selectedProduct){
				// 		_this.$message.error('请先选择提货产品，再添加新卡');
				// 		_this.isCheck = true;
				// 		return false;
				// 	}
				// });

				_this.isCheck = true;
				_this.server.post("/TakeOrder/GetInfoByCardNumber", { Number: _this.Card.Number, Password: _this.Card.Password })
					.then((res)=>{
						let data = res.data;
						if (data.State==1) {
							
							// data.Data.product = data.Data.product.filter((item)=>{
							// 	return !item.Deleted;
							// });
							// //selectedProduct
							// if(data.Data.product.length==1){
							// 	data.Data.selectedProduct = data.Data.product[0];
							// }
							// _this.CardList.push(data.Data);
							// _this.cardIndex=_this.CardList.length-1;
							// //_this.getRule();//获取卡券的预约规则
							// //_this.Take.ExpectDeliveredDate = ""; //每次验证完卡券后初始化日期
							// //_this.rebuildProvince();
							var m=data.Data;
							m.Password=_this.Card.Password;
                            m.SelectProducts=[];
							m.SelectedProPrice=0;
							m.Spids=[];
                            _this.CardList.push(m);
						}
						else
						{
							// console.log(1);
							// //_this.$message.error(data.ErrorMsg);
							// _this.$message({
							// 	showClose: true,
							// 	message: data.ErrorMsg,
							// 	type: 'success'
							// 	});
						}
						_this.isCheck = false;
					}).catch((err)=>{
					_this.isCheck = false;
				})
			},
			delCard: function (index) {
				if(confirm("确定删除该卡券吗？之后可以重新添加")){
					this.CardList.splice(index, 1);
				}
			},
			//重新构建省市区选择范围
			rebuildProvince(){
				
				let _this = this;
				let limit_province = [];
				let limit_all=false;
				_this.CardList.forEach(item=>{
					item.SelectProducts.forEach(s=>{
						if(s.AllowProvinces){
							let limit =s.AllowProvinces.split(",");
							//limit_province = [...limit_province, ...limit];
							let current_limit=[];
							if(limit_province && limit_province.length>0){
								limit_province = _this.lodash.intersection(limit_province, limit);
							}else {
								limit_province = limit;
							}
							if(limit_province.length==0)
								limit_all=true;
						}
					})
					
				});
				limit_province = _this.lodash.uniq(limit_province);
				if(limit_province.length>0){
					_this.Province = {};
					_this.City = {};
					_this.District = {};

					_this.AllProvinces = _this.allAddress.filter((item)=>{
						return limit_province.indexOf(item.fullName) != -1;
					});
					_this.Cities = [];
					_this.Districts= [];
				}else {
					//_this.AllProvinces = _this.lodash.cloneDeep(_this.allAddress);
					if(limit_all){
						_this.AllProvinces=[];
						_this.$message({message:"您选择的多个产品中，配送范围没有同一省份，请分开预约",type:"warning"});
					}
					else{
						_this.AllProvinces = _this.lodash.cloneDeep(_this.allAddress);
					}
				}

			},
			getCity: function (value) {
				this.City = {};
				this.District = {};
				this.Cities = value.city;
			},
			getDistrict: function (value) {
				this.District = {};
				this.Districts = value.county;
			},
			// $message.error: function(msg="", type="warning", time=3000){
			// 	//msg 提示信息 type
			// 	//提示类型 error success warning info
			// 	//time 显示时间 设0时不关闭
			// 	let _this = this;
			// 	_this.$message({
			// 		showClose: true,
			// 		message: msg,
			// 		type: type,
			// 		duration: time,
			// 		customClass: "$message.error"
			// 	});
			// },
			CustomerTake: function () {
				var _this = this;
				
				var date = new Date(_this.Take.ExpectDeliveredDate);
				var dateStr = date.getFullYear() + "-" + (date.getMonth()+1) + "-" + date.getDate();
				var Model = {
					Name: _this.Take.Name,
					Phone: _this.Take.Phone,
					Remark: _this.Take.Remark,
					Province: _this.Province.fullName,
					City: _this.City.fullName,
					District: _this.District.fullName,
					Address: _this.Take.Address,
					ExpectDeliveredDate: dateStr,
					StoreId: "",
					PickUpInStore: false,
					Items:[],
				};
				//$scope.Model.ProductModels = $scope.SelectedProduct;
				var sp="";
                _this.CardList.forEach(x=>{
                    sp+="卡号("+x.Number+")：";
                    x.SelectProducts.forEach(p=>{
                        var isNew=false;
                        if(Model.Items){
                            var old=Model.Items.filter(i=>i.ProductId==p.Id);
                            if(old.length>0){
                                old[0].Count+=p.Count;
                            }else{
                                isNew=true;
                            }
                        }
                        if(isNew){
                            Model.Items.push({
                                Name: p.Name,
                                ProductId: p.Id,
                                Count: p.Count,
                                CardNumber: x.Number,
                                CardId: x.Id
                            })
                        }
                        sp+=p.Name+"X"+p.Count+","
                    })
                    sp=sp.substr(0, sp.length - 1);
                    sp+=";";
				});
                var cardMap=_this.lodash.cloneDeep(_this.CardList);
                cardMap=cardMap.map(x=>{
                    x.Products=undefined;
                    return x;
                });
                Model.CardMap=JSON.stringify(cardMap);
				Model.Cards=_this.CardList;
				
				Model.Items=Model.Items.filter(x=>x.Count>0);
				Model.SelectedProduct=sp;
				

				if (!Model.Province || !Model.City || !Model.District || !Model.Address) {
					_this.$message.error('请完善地址的填写!');
					return false;
				}

				if (!Model.Name || !Model.Phone) {
					_this.$message.error('请完善收货人姓名及联系方式!');
					return false;
				}

				if (!(/^1[3456789]\d{9}$/.test(Model.Phone))) {
					_this.$message.error('请填写正确的手机号码!');
					return false;
				}


				if (Model.ExpectDeliveredDate =="NaN-NaN-NaN") {
					_this.$message.error('请选择收货日期， 且收货日期至少为当前日期一天之后!');
					return false;
				}
				if (Model.Items.length == 0) {
					_this.$message.error('您还没有验证卡券!');
					return false;
				}
				_this.isPost=true;
				_this.server.post("/TakeOrder/CustomerTakeOrder", Model)
					.then((res)=>{
						let data = res.data;
						if (data.State==1) {
							//初始化
							_this.Take = {};
							_this.Card = {};
							_this.CardList = [];
							_this.Province = {};
							_this.City = {};
							_this.District = {};
							_this.active = 1
							_this.$alert('您已预约成功，我们会按照您的预约时间为您发货', '提示', {
								confirmButtonText: '确定',
								customClass: "takeSuccess",
								callback: function () {

								}
							});
						} else {
							// if(data.ErrorMsg){
							// 	_this.$message.error(data.ErrorMsg);
							// }
							// if(data.TimeSpanStr){
							// 	_this.Take.TimeSpanStr=data.TimeSpanStr;
							// }
						}
						_this.isPost = false;
					}).catch((err)=>{
					_this.isPost = false;
				})
			}
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
	.customerTake{
		//background-image: url("/static/img/bg.jpg");
		background-size: 100% 100%;
		background-repeat: no-repeat;
		background-position: center;
		padding-left: 5px;
		padding-right: 5px;
		position: absolute;
		height: 100%;
		width: 100%;
		padding-top: 30px;
		padding-bottom: 30px;
		overflow-y: scroll;
		h2{
			text-align: center;
			color: #fff;
		}
		.mstep{
			margin-bottom: 20px;
		}

		.el-card__header{
			padding-top: 5px;
			padding-bottom: 5px;
		}
		.box-card{
			margin-top: 15px;
		}
		.el-form-item__label{
			color: #fff;
		}
		.el-step__title.is-process{
			color: #fff;
		}

		.focuson{
			text-align: center;
			margin-top: 30px;
			img{
				max-width: 150px;
			}
			p{
				color: #fff;
				font-size: 12px;
			}
		}

		.company_logo{
			text-align: center;
			img{
				/*max-width: 400px;*/
				max-height: 200px;
			}
		}

	}

	.el-message-box.takeSuccess{
		width: 100%;
	}

	@media (max-width: 768px) {
		.tipmsg{
			width: 90% !important;
		}
		.company_logo{
			img{
				/*max-width: 100% !important;*/
				max-height: 100px !important;
				max-width: 100%;
			}
		}
	}

	#showiframe{
		position: absolute;
		height: 100%;
		width: 100%;
		top: 0;
		z-index: 9999;
	}

	.pre-select-pro{
		text-align: center;
		cursor: pointer;
		padding: 5px 0 5px;
	}
	.proPanel, .selected-pro{
		.pro-panel-wrap{
			display: table;
			height: 100px;
			width: 100%;
			border:1px solid #848484;
			border-radius:10px;
			margin-bottom: 5px;
			position:relative;
			.panel-left{
				display: table-cell;
				width: 100px;
				height: 100px;
				text-align: center;
				vertical-align: middle;
				line-height: 0;
				img{
					width: 100%;
					height: 100%;
					border-top-left-radius:10px;
  					border-bottom-left-radius:10px;
				}
			}
			.panel-mid{
				display: table-cell;
				h4{
					padding: 0px;
					margin: 0px;
					padding-left: 10px;
					padding-top: 15px;
					font-size: 14px;
					width: 85%;
				}
				p{
					padding-left: 10px;
					font-size: 10px;
					line-height: 1.5em;
					overflow:hidden;
					text-overflow:ellipsis;
					display:-webkit-box;
					-webkit-line-clamp:3;
					-webkit-box-orient:vertical;
					width: 85%;
				}
			}
			.panel-right{
				font-size:22px;
				position:absolute;
				top:50%;
				right:1%;
				transform: translate(-50%, -50%); 
			}
			.panel-checked{
				
				position:absolute;
				top:1px;
				left:1px;
				i{
					font-size:22px;
					color:#4dd495;
					width: 22px;
					height:22px;
					border-radius:11px;
				}
				
			}
		}
		.pro-select{
			
			border:1px solid #4dd495;
		}
	}
	.selected-pro{
		padding: 10px;
	}
	.card_title{
		span{
			font-size: 14px;
			overflow:hidden;
			text-overflow:ellipsis;
			display:-webkit-box;
			-webkit-line-clamp:1;
			-webkit-box-orient:vertical;
		}
	}
	.el-collapse-item__content{
		padding-bottom: 0px;
	}
	.el-card__body{
		padding: 10px;
	}
	.proDetail .el-dialog__header{
		position: fixed;
		top: 0;
		width: 100%;
		padding: 20px;
		background: #fff;
	}
	.proDetail .el-dialog__body{
		padding: 10px;
		margin-top: 50px;
	}
	@media (max-width: 768px) {
		.proDetail{
			width: 100% !important;
			margin-top:0px !important;
		}
	}
	.sum_table{
		background-color: #fff;
		border:1px solid #848484;
		border-collapse: collapse; 
		padding:5px;
		width: 100%;
	}
	.sum_table_title{
		width:35%;
		font-size: 12px;
		text-align:right;
	}
	.sum_cell{
		width:100%;
		height: 100%;
		padding: 10px;
	}
	.sum_tips{
		font-size: 12px;
		color:#F56C6C;
	}
	.proPiont{
		position:absolute;
		right:5px;
		bottom: 5px;
	}
</style>
